function initScrollObserver(container = document) {
  const elements = container.querySelectorAll('[data-scroll-watch]');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      entry.target.classList.toggle('in-view', entry.isIntersecting);
      entry.target.classList.toggle('out-of-view', !entry.isIntersecting);
    });
  }, {
    threshold: 0.15
  });

  elements.forEach(el => observer.observe(el));
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  initScrollObserver();
});

// Horizon / OS 2.0 section reloads
document.addEventListener('shopify:section:load', (event) => {
  initScrollObserver(event.target);
});
